import { Box, Typography } from 'src/components';

const TABLE_MIN_WIDTH = 650;
const BORDER_RADIUS = 8;

function TableWrapper({ children }) {
  return (
    <Box
      className="table-scroll"
      sx={{
        width: '100%',
        overflowX: 'auto',
        WebkitOverflowScrolling: 'touch',
        borderRadius: BORDER_RADIUS,
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        bgcolor: 'background.paper',
        p: { xs: 0.5, sm: 1.5 },
        mb: 1
      }}
    >
      <Box
        component="table"
        sx={{
          width: '100%',
          minWidth: TABLE_MIN_WIDTH,
          borderCollapse: 'separate',
          borderSpacing: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
}

function TableHead({ children, ...rest }) {
  return <Box component="thead" {...rest}>{children}</Box>;
}

function TableBody({ children, ...rest }) {
  return <Box component="tbody" {...rest}>{children}</Box>;
}

function TableRow({ children, ...rest }) {
  return (
    <Box
      component="tr"
      {...rest}
      sx={{
        '&:last-child td': { borderBottom: 'none' },
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover td': { backgroundColor: 'action.hover' },
        },
      }}
    >
      {children}
    </Box>
  );
}

function TableHeadCell({ children, ...rest }) {
  return (
    <Box
      component="th"
      scope="col"
      {...rest}
      sx={(theme) => ({
        p: { xs: 1, sm: 1.25 },
        fontWeight: 600,
        fontSize: { xs: '0.82rem', sm: '0.95rem' },
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        backgroundColor: theme.palette.mode === 'light' ? 'grey.50' : 'grey.900',
        position: 'sticky',
        top: 0,
        zIndex: 2,
        '&:first-of-type': {
          borderTopLeftRadius: BORDER_RADIUS,
          paddingLeft: { xs: 1, sm: 1.5 },
        },
        '&:last-of-type': {
          borderTopRightRadius: BORDER_RADIUS,
          paddingRight: { xs: 1, sm: 1.5 },
        },
        '@media (max-width:600px)': {
          position: 'static',
          top: 'auto',
        },
      })}
    >
        <Typography
            variant="subtitle1"
            fontWeight={600}
            component="span"
            sx={{ lineHeight: 1.45, display: 'inline', float: 'left' }}>
                {children}
        </Typography>
    </Box>
  );
}

function TableCell({ children, ...rest }) {
  return (
    <Box
      component="td"
      {...rest}
      sx={{
        p: { xs: 0.75, sm: 1.25 },
        pl: { xs: 1, sm: 1.5 }, // consistent left padding
        pr: { xs: 1, sm: 1.5 }, // consistent right padding
        fontSize: { xs: '0.82rem', sm: '0.95rem' },
        verticalAlign: 'middle',
        borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        color: 'text.primary'
      }}
    >
      <Typography
        variant="body2"
        component="span"
        sx={{ lineHeight: 1.45, display: 'inline', float: 'left', textAlign: 'left' }}>
            {children}
        </Typography>
    </Box>
  );
}

const markdownTableComponents = {
  table: TableWrapper,
  thead: TableHead,
  tbody: TableBody,
  tr: TableRow,
  th: TableHeadCell,
  td: TableCell,
};

export default markdownTableComponents;
